import { useFormik } from 'formik';
// mantine
import { Button, TextInput, CloseButton } from '@mantine/core';
// icons
import { Send, AtSign } from 'lucide-react';
// utils
import validationSchema from '@/pages/Sessions/components/ExportSessionsButton/components/ExportSessionForm/ExportSessionForm.schema.ts';

type ExportSessionsButtonFormPropsType = {
    onSubmit: (email: string) => Promise<unknown>;
    email: string;
};

const ExportSessionsForm = ({
    onSubmit,
    email
}: ExportSessionsButtonFormPropsType) => {
    const initialValues = {
        email
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: ({ email: formEmail }) => {
            onSubmit(formEmail)
                .catch(console.error)
                .finally(() => {
                    formik.setSubmitting(false);
                });
        },
        validateOnChange: true
    });

    return (
        <form autoComplete="off" onSubmit={formik.handleSubmit}>
            <TextInput
                className="flex-1 md:max-w-lg mr-auto mb-6"
                error={formik.touched.email ? formik.errors.email : undefined}
                leftSection={<AtSign size={16} />}
                placeholder="Enter email address"
                rightSection={
                    formik.values.email ? (
                        <CloseButton
                            onClick={() => {
                                formik.setFieldValue('email', '');
                            }}
                        />
                    ) : undefined
                }
                rightSectionPointerEvents="all"
                size="xs"
                type="email"
                value={formik.values.email}
                onBlur={formik.handleBlur}
                onChange={(event_) => {
                    formik.setFieldValue('email', event_.target.value);
                }}
            />
            <Button
                fullWidth
                leftSection={<Send />}
                loading={formik.isSubmitting}
                type="submit"
            >
                {formik.isSubmitting ? 'Loading...' : 'Send session report'}
            </Button>
        </form>
    );
};

export default ExportSessionsForm;
